(function () {
  'use strict';

  var MAX_DEFAULT = 4;
  var STAR = '\u2605';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function firstName(full) {
    if (!full) return '';
    var t = String(full).trim();
    if (!t) return '';
    return t.split(/\s+/)[0];
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function parseReviewsFromHtml(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html || '';
    var nodes = wrap.querySelectorAll('.jdgm-rev');
    var out = [];
    nodes.forEach(function (node) {
      var ratingEl = node.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? parseFloat(ratingEl.getAttribute('data-score') || '0') : 0;
      if (score !== 5) return;
      var authorEl = node.querySelector('.jdgm-rev__author');
      var titleEl = node.querySelector('.jdgm-rev__title');
      var bodyEl = node.querySelector('.jdgm-rev__body');
      var body = bodyEl ? stripHtml(bodyEl.innerHTML) : '';
      if (!body) return;
      out.push({
        score: 5,
        author: firstName(authorEl ? authorEl.textContent : ''),
        title: titleEl ? stripHtml(titleEl.innerHTML) : '',
        body: body
      });
    });
    return out;
  }

  function buildCard(review) {
    var li = document.createElement('li');
    li.className = 'msm-gallery-reviews__card';

    var stars = document.createElement('div');
    stars.className = 'msm-gallery-reviews__stars';
    stars.setAttribute('aria-label', '5 star review');
    stars.setAttribute('role', 'img');
    stars.textContent = STAR + STAR + STAR + STAR + STAR;
    li.appendChild(stars);

    if (review.title) {
      var title = document.createElement('p');
      title.className = 'msm-gallery-reviews__card-title';
      title.textContent = review.title;
      li.appendChild(title);
    }

    var body = document.createElement('p');
    body.className = 'msm-gallery-reviews__body';
    body.textContent = review.body;
    li.appendChild(body);

    if (review.author) {
      var meta = document.createElement('p');
      meta.className = 'msm-gallery-reviews__meta';
      meta.textContent = review.author;
      li.appendChild(meta);
    }

    return li;
  }

  function scrollToMoreReviews() {
    var full =
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('[id*="judge_me_reviews_review_widget"]');
    if (full) {
      full.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var badge = document.querySelector('.jdgm-preview-badge, .jdgm-prev-badge');
    if (badge) {
      badge.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try {
        badge.click();
      } catch (e) {}
    }
  }

  function setupDots(root, list, count) {
    var dotsWrap = qs(root, '[data-msm-gallery-reviews-dots]');
    if (!dotsWrap) return;
    dotsWrap.innerHTML = '';
    if (count < 2) {
      dotsWrap.hidden = true;
      return;
    }
    dotsWrap.hidden = false;
    var dots = [];
    for (var i = 0; i < count; i++) {
      (function (index) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'msm-gallery-reviews__dot' + (index === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Review ' + (index + 1));
        btn.addEventListener('click', function () {
          var cards = list.children;
          if (cards[index]) {
            cards[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          }
        });
        dotsWrap.appendChild(btn);
        dots.push(btn);
      })(i);
    }

    function syncActive() {
      var cards = list.children;
      if (!cards.length) return;
      var best = 0;
      var bestDist = Infinity;
      var left = list.scrollLeft;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(cards[i].offsetLeft - left);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      dots.forEach(function (d, idx) {
        if (idx === best) d.classList.add('is-active');
        else d.classList.remove('is-active');
      });
    }

    var ticking = false;
    list.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          syncActive();
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function render(root, reviews, max) {
    var list = qs(root, '[data-msm-gallery-reviews-list]');
    if (!list) return;

    list.innerHTML = '';
    var slice = reviews.slice(0, max);
    if (!slice.length) {
      root.setAttribute('hidden', '');
      return;
    }

    slice.forEach(function (r) {
      list.appendChild(buildCard(r));
    });
    root.removeAttribute('hidden');
    setupDots(root, list, slice.length);

    var brand = qs(root, '[data-msm-gallery-reviews-brand]');
    if (brand) {
      brand.onclick = function (e) {
        e.preventDefault();
        scrollToMoreReviews();
      };
    }

  }

  function fetchReviews(shopDomain, productId) {
    var url =
      'https://judge.me/reviews/reviews_for_widget?url=' +
      encodeURIComponent(shopDomain) +
      '&shop_domain=' +
      encodeURIComponent(shopDomain) +
      '&platform=shopify&page=1&per_page=50&product_id=' +
      encodeURIComponent(productId);
    return fetch(url, { credentials: 'omit' }).then(function (res) {
      if (!res.ok) throw new Error('Judge.me HTTP ' + res.status);
      return res.json();
    });
  }

  function initOne(root) {
    var productId = root.getAttribute('data-product-id');
    var shopDomain = root.getAttribute('data-shop-domain') || 'meat-supermarket-com.myshopify.com';
    var max = parseInt(root.getAttribute('data-max') || String(MAX_DEFAULT), 10) || MAX_DEFAULT;
    if (!productId) {
      root.setAttribute('hidden', '');
      return;
    }

    var embedded = qs(root, '[data-msm-gallery-reviews-source]');
    var embeddedHtml = '';
    if (embedded) {
      if (embedded.tagName === 'TEMPLATE') {
        var tmp = document.createElement('div');
        tmp.appendChild(embedded.content.cloneNode(true));
        embeddedHtml = tmp.innerHTML;
      } else {
        embeddedHtml = embedded.innerHTML;
      }
    }
    var fromEmbed = embeddedHtml ? parseReviewsFromHtml(embeddedHtml) : [];

    function finish(reviews) {
      render(root, reviews, max);
    }

    if (fromEmbed.length >= max) {
      finish(fromEmbed);
      return;
    }

    fetchReviews(shopDomain, productId)
      .then(function (data) {
        var fetched = parseReviewsFromHtml(data && data.html ? data.html : '');
        var seen = {};
        var merged = [];
        fromEmbed.concat(fetched).forEach(function (r) {
          var key = (r.author || '') + '|' + (r.body || '');
          if (seen[key]) return;
          seen[key] = true;
          merged.push(r);
        });
        finish(merged);
      })
      .catch(function () {
        if (fromEmbed.length) finish(fromEmbed);
        else root.setAttribute('hidden', '');
      });
  }

  function boot() {
    document.querySelectorAll('[data-msm-gallery-reviews]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
